import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { DatosUsuarioForm } from '@app/components/auth/DatosUsuarioForm/DatosUsuarioForm';

const DatosUsuarioPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Datos del usuario')}</PageTitle>
      <DatosUsuarioForm />
    </>
  );
};

export default DatosUsuarioPage;
